export const toSafeString = (value) => {
  return String(value || '').trim();
};
